import { useEffect } from "react"
import { useNavigate } from "react-router-dom";
function AvailableRooms() {
    const navigate = useNavigate();
    useEffect(() => {
        const scriptUrls = [
            '/assets/js/jquery.min.js',
            '/assets/js/bootstrap.bundle.min.js',
            '/assets/js/moment.min.js',
            '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
            '/assets/vendor/overlay-scroll/custom-scrollbar.js',
            '/assets/vendor/daterange/daterange.js',
            '/assets/vendor/daterange/custom-daterange.js',
            '/assets/vendor/jquery-ui/jquery-ui.min.js',
            '/assets/vendor/jquery-ui/custom.js',
            '/assets/vendor/datatables/dataTables.min.js',
            '/assets/vendor/datatables/dataTables.bootstrap.min.js',
            '/assets/vendor/datatables/custom/custom-datatables.js',
            '/assets/js/custom.js',


        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () => {
            for (const url of scriptUrls) {
                if (isCancelled) break;

                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);
    const handleSubmit = () => {
        // Optional: Add form validation logic here
        navigate("/book-rooms");
        setTimeout(() => {
            window.location.reload(); // force page refresh after navigation
        }, 100);
    };
    return (<>

        <div className="app-hero-header d-flex align-items-center">
            {/* Breadcrumb starts */}
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                    <a href="index-2.html">
                        <i className="ri-home-3-line" />
                    </a>
                </li>
                <li className="breadcrumb-item">Rooms</li>
                <li className="breadcrumb-item text-primary" aria-current="page">
                    Available Rooms
                </li>
            </ol>
            {/* Breadcrumb ends */}
            {/* Sales stats starts */}
            <div className="ms-auto d-lg-flex d-none flex-row">
                <div className="input-group">
                    <span className="input-group-text bg-primary-lighten">
                        <i className="ri-calendar-2-line text-primary" />
                    </span>
                    <input type="text" id="abc" className="form-control custom-daterange" />
                </div>
            </div>
            {/* Sales stats ends */}
        </div>
        {/* App Hero header ends */}
        {/* App body starts */}
        <div className="app-body">
            {/* Row starts */}
            <div className="row gx-4">
                <div className="col-lg-6 col-sm-12">
                    <div className="card mb-4">
                        <div className="card-header">
                            <h5 className="card-title">Cardiology</h5>
                        </div>
                        <div className="card-body pt-0">
                            {/* Table starts */}
                            <div className="table-outer">
                                <div className="table-responsive">
                                    <table className="table truncate align-middle m-0">
                                        <thead>
                                            <tr>
                                                <th>Room No.</th>
                                                <th>Bed No.</th>
                                                <th>Room Type</th>
                                                <th>Availability</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    203
                                                </td>
                                                <td>3</td>
                                                <td>Private</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    308
                                                </td>
                                                <td>2</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    406
                                                </td>
                                                <td>5</td>
                                                <td>Suite</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    302
                                                </td>
                                                <td>2</td>
                                                <td>Standard</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    605
                                                </td>
                                                <td>4</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* Table ends */}
                        </div>
                    </div>
                    <div className="card mb-4">
                        <div className="card-header">
                            <h5 className="card-title">Gastroenterology</h5>
                        </div>
                        <div className="card-body pt-0">
                            {/* Table starts */}
                            <div className="table-outer">
                                <div className="table-responsive">
                                    <table className="table truncate align-middle m-0">
                                        <thead>
                                            <tr>
                                                <th>Room No.</th>
                                                <th>Bed No.</th>
                                                <th>Room Type</th>
                                                <th>Availability</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    502
                                                </td>
                                                <td>1</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    307
                                                </td>
                                                <td>2</td>
                                                <td>Standard</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    408
                                                </td>
                                                <td>4</td>
                                                <td>Suite</td>

                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    303
                                                </td>
                                                <td>2</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* Table ends */}
                        </div>
                    </div>
                    <div className="card mb-4">
                        <div className="card-header">
                            <h5 className="card-title">Paediatrician</h5>
                        </div>
                        <div className="card-body pt-0">
                            {/* Table starts */}
                            <div className="table-outer">
                                <div className="table-responsive">
                                    <table className="table truncate align-middle m-0">
                                        <thead>
                                            <tr>
                                                <th>Room No.</th>
                                                <th>Bed No.</th>
                                                <th>Room Type</th>
                                                <th>Availability</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    103
                                                </td>
                                                <td>2</td>
                                                <td>Suite</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    205
                                                </td>
                                                <td>3</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    502
                                                </td>
                                                <td>4</td>
                                                <td>Standard</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* Table ends */}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="card mb-4">
                        <div className="card-header">
                            <h5 className="card-title">Orthopedics</h5>
                        </div>
                        <div className="card-body pt-0">
                            {/* Table starts */}
                            <div className="table-outer">
                                <div className="table-responsive">
                                    <table className="table truncate align-middle m-0">
                                        <thead>
                                            <tr>
                                                <th>Room No.</th>
                                                <th>Bed No.</th>
                                                <th>Room Type</th>
                                                <th>Availability</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    203
                                                </td>
                                                <td>3</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    208
                                                </td>
                                                <td>3</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    105
                                                </td>
                                                <td>1</td>
                                                <td>Suite</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* Table ends */}
                        </div>
                    </div>
                    <div className="card mb-4">
                        <div className="card-header">
                            <h5 className="card-title">Anatomy</h5>
                        </div>
                        <div className="card-body pt-0">
                            {/* Table starts */}
                            <div className="table-outer">
                                <div className="table-responsive">
                                    <table className="table truncate align-middle m-0">
                                        <thead>
                                            <tr>
                                                <th>Room No.</th>
                                                <th>Bed No.</th>
                                                <th>Room Type</th>
                                                <th>Availability</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>303</td>
                                                <td>3</td>
                                                <td>Standard</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>209</td>
                                                <td>3</td>
                                                <td>Private</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>106</td>
                                                <td>2</td>
                                                <td>Suite</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>102</td>
                                                <td>4</td>
                                                <td>Delux</td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={handleSubmit}
                                                    >
                                                        Book Now
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            {/* Table ends */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Row ends */}
        </div>
        {/* App body ends */}


        {/* App container ends */}


    </>)
}
export default AvailableRooms;
